import { Fragment } from "react"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react"
import { ChevronDownIcon } from "@heroicons/react/20/solid"
import clsx from "clsx"
import Button from "@/components/Button"
import { Modals, useModals } from "@/hooks/useModals"
import downloadPgn from "@/utils/downloadPgn"
import { Event, ExportEvent } from "@/types/serializers"
import toast from "react-hot-toast"
import { router } from "@inertiajs/react"
import axios from "axios"

const ActionsDropdown = ({ event }: { event: Event }) => {
  const { openModal } = useModals()

  const noGames = Boolean(event.games?.length === 0)

  const handleExport = async () => {
    try {
      const { data } = await axios.get<ExportEvent>(`/api/events/${event.id}`)

      data.games && data.games.length > 0
        ? downloadPgn(data.games, data.name || "Untitled event")
        : toast.error("This event has no games")
    } catch (error) {
      console.log(error)
      toast.error("Error exporting event")
    }
  }

  const handleDeleteEvent = () => {
    const hasGames = event.games && event.games.length > 0

    // Show modal to choose what happens to the games if event has any
    if (hasGames) return openModal(Modals.DeleteEvent)

    // Otherwise just show a browser confirmation box
    const confirmation = confirm("Are you sure you want to delete this event?")

    if (!confirmation) return

    router.delete(`/events/${event.id}`, {
      async: true,
    })
  }

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <MenuButton as={Fragment}>
          <Button size="sm" style="secondary">
            <span className="sr-only">Options</span>
            <ChevronDownIcon
              className="ui-open:rotate-180 h-5 w-5 transition-transform duration-100 ease-out"
              aria-hidden="true"
            />
          </Button>
        </MenuButton>
      </div>

      <MenuItems
        transition
        className={clsx([
          "absolute left-0 z-10 mt-2 w-36 origin-top-left overflow-hidden rounded-xl bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none sm:right-0 sm:origin-top-right",
          "data-closed:scale-95 data-closed:opacity-0",
          "data-enter:duration-100 data-enter:ease-out",
          "data-leave:duration-75 data-leave:ease-in",
        ])}
      >
        <div className="py-2">
          <MenuItem>
            <button
              onClick={handleExport}
              disabled={noGames}
              className="block w-full px-4 py-3 text-left text-sm text-gray-700 disabled:opacity-30 data-focus:enabled:bg-gray-100 data-focus:enabled:text-gray-900"
            >
              Export as PGN
            </button>
          </MenuItem>
          <MenuItem>
            <button
              onClick={handleDeleteEvent}
              className="block w-full px-4 py-3 text-left text-sm text-gray-700 disabled:opacity-30 data-focus:bg-gray-100 data-focus:text-gray-900"
            >
              Delete event
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  )
}

export default ActionsDropdown
